import { getCounterValue } from '../Counter'

import {
  ENTITY_EXTRA_TAGS_RATING_AVG,
  QA_NAME_ENTITY_EXTRA_TAGS_AUTOMATION,
  QA_NAME_ENTITY_EXTRA_TAGS_CONTRACTOR,
  QA_NAME_ENTITY_EXTRA_TAGS_DOC_FLOW,
  QA_NAME_ENTITY_EXTRA_TAGS_EMAIL,
  QA_NAME_ENTITY_EXTRA_TAGS_EPOST,
  QA_NAME_ENTITY_EXTRA_TAGS_FILES,
  QA_NAME_ENTITY_EXTRA_TAGS_INVOICE,
  QA_NAME_ENTITY_EXTRA_TAGS_MESSAGE,
  QA_NAME_ENTITY_EXTRA_TAGS_ORDER,
  QA_NAME_ENTITY_EXTRA_TAGS_RELATED,
  QA_NAME_ENTITY_EXTRA_TAGS_TASK,
} from './EntityExtraTags.constants'
import {
  getTooltipChat,
  getTooltipEmail,
  getTooltipEpost,
  getTooltipText,
} from './EntityExtraTags.utils.tooltip'
import { EntityExtraTagsItem } from './EntityExtraTagsItem'

import AttachIcon from '../../icons/attach.svg'
import AutomationIcon from '../../icons/automate.svg'
import MessageIcon from '../../icons/chats.svg'
import DocFlowIcon from '../../icons/doc-splitting.svg'
import EpostIcon from '../../icons/e-post-billing.svg'
import EmailIcon from '../../icons/email.svg'
import InvoiceIcon from '../../icons/invoice.svg'
import OrderIcon from '../../icons/orders.svg'
import ProviderIcon from '../../icons/providers.svg'
import RelatedIcon from '../../icons/related-sr.svg'
import TaskIcon from '../../icons/task.svg'

export function getTags({ item, rules, t }) {
  const items = [
    {
      Icon: EmailIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.EmailsCount],
      errorCount: getCounterValue(item?.[rules.ErrorMessagesCount]),
      newCount: getCounterValue(item?.[rules.UnreadEmailsCount]),
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_EMAIL,
      show:
        !!item?.[rules.EmailsCount] ||
        !!item?.[rules.UnreadEmailsCount] ||
        !!item?.[rules.ErrorMessagesCount],
      text: t('RequestTable.TagThreadEmailsKey'),
      tooltip: getTooltipEmail({
        all: item?.[rules.EmailsCount],
        error: item?.[rules.ErrorMessagesCount],
        t,
        unread: item?.[rules.UnreadEmailsCount],
      }),
    },
    {
      Icon: MessageIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.ChatMessagesCount],
      errorCount: null,
      newCount: getCounterValue(item?.[rules.UnreadChatMessagesCount]),
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_MESSAGE,
      show: !!item?.[rules.ChatMessagesCount],
      text: t('RequestTable.TagChatMessagesKey'),
      tooltip: getTooltipChat({
        all: item?.[rules.ChatMessagesCount],
        error: 0,
        t,
        unread: item?.[rules.UnreadChatMessagesCount],
      }),
    },
    {
      Icon: TaskIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.OpenTasksCount],
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_TASK,
      show: !!item?.[rules.HasActivities],
      text: t('RequestTable.TagActivityKey'),
      tooltip: getTooltipText(
        t('RequestTable.IconActivityTooltipKey'),
        item?.[rules.OpenTasksCount]
      ),
    },
    {
      Icon: InvoiceIcon,
      Tag: EntityExtraTagsItem,
      count: null,
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_INVOICE,
      show: !!item?.[rules.HasInvoices],
      text: t('RequestTable.TagInvoicesKey'),
      tooltip: getTooltipText(t('RequestTable.IconInvoiceTooltipKey')),
    },
    {
      Icon: ProviderIcon,
      Tag: EntityExtraTagsItem,
      count: null,
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_CONTRACTOR,
      show: !!item?.[rules.HasContractors],
      text: t('RequestTable.TagContractorsKey'),
      tooltip: getTooltipText(t('RequestTable.IconContractorsTooltipKey')),
    },
    {
      Icon: OrderIcon,
      Tag: EntityExtraTagsItem,
      count: null,
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_ORDER,
      show: !!item?.[rules.HasOrders],
      text: t('RequestTable.TagOrdersKey'),
      tooltip: getTooltipText(t('RequestTable.IconOrdersTooltipKey')),
    },
    {
      Icon: AttachIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.FilesCount],
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_FILES,
      show: !!item?.[rules.FilesCount],
      text: t('RequestTable.TagFilesKey'),
      tooltip: getTooltipText(
        t('RequestTable.IconFilesTooltipKey'),
        item?.[rules.FilesCount]
      ),
    },
    {
      Icon: RelatedIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.RelatedRequestsCount],
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_RELATED,
      show: !!item?.[rules.RelatedRequestsCount],
      text: t('RequestTable.TagRelatedRequestsKey'),
      tooltip: getTooltipText(
        t('RequestTable.IconRelatedRequestsTooltipKey'),
        item?.[rules.RelatedRequestsCount]
      ),
    },
    {
      Icon: DocFlowIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.DocFlowsCount],
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_DOC_FLOW,
      show: !!item?.[rules.DocFlowsCount],
      text: t('RequestTable.TagDocFlowsKey'),
      tooltip: getTooltipText(
        t('RequestTable.IconDocFlowsTooltipKey'),
        item?.[rules.DocFlowsCount]
      ),
    },
    {
      Icon: AutomationIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.ActiveAutomationsCount],
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_AUTOMATION,
      show: !!item?.[rules.ActiveAutomationsCount],
      text: t('Table.TagActiveAutomationsKey'),
      tooltip: getTooltipText(
        t('Table.IconActiveAutomationsTooltipKey'),
        item?.[rules.ActiveAutomationsCount]
      ),
    },
    {
      Icon: EpostIcon,
      Tag: EntityExtraTagsItem,
      count: item?.[rules.EpostCount],
      errorCount: getCounterValue(item?.[rules.ErrorEpostCount]),
      qaName: QA_NAME_ENTITY_EXTRA_TAGS_EPOST,
      show: !!item?.[rules.EpostCount] || !!item?.[rules.ErrorEpostCount],
      text: t('Table.TagEpostKey'),
      tooltip: getTooltipEpost({
        all: item?.[rules.EpostCount],
        error: item?.[rules.ErrorEpostCount],
        t,
      }),
    },
  ]

  return items.filter(item => item.show)
}

export function getEntityExtraTagsItem({ extra, id }) {
  return extra?.items?.find(extraItem => extraItem.id === id) ?? null
}

export function hasEntityExtraTags({ item, tagList }) {
  return (
    Boolean(item) &&
    (tagList.length > 0 || Boolean(item[ENTITY_EXTRA_TAGS_RATING_AVG]))
  )
}
